<template>
    <div id="PermitCustomerList">
        <div :class="`loader${loaderClass}`" v-show="loading">

        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">Processed Permit List
                        <data-table-column-config :moduleName="'processedPermitList'"></data-table-column-config>
                        <div class="web-action-btn">
                           <button type="submit" class="btn btn-success waves-effect pull-right back-btn-fl" v-on:click.prevent="BackVehiclePermitList" >
                               <i class="hi-icon icon-flback"> </i> Back
                            </button>
                        </div>
                    </div>
                    <div class="admin-page-content customer-detail">
                        <data-table-filter-config :moduleName="'processedPermitList'" @cancelSelection="cancelAll"></data-table-filter-config>
                        <section class="internal-container">
                            <div class="container">
                                <vue-good-table
                            ref="listPermitCustomerTable"
                            mode="remote"
                            title="Permit"
                            @on-page-change="onPageChange"
                            @on-selected-rows-change="selectionChanged"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
                            @on-sort-change="onSortChange"
                            :totalRows="totalRecords"
                            :columns="userColumns"
                            :rows="rows"
                            :pagination-options="{
                                enabled: true,
                                position: 'both',
                                perPage: perPage,
                                perPageDropdown:dropDownPerPage,
                                dropdownAllowAll: false,
                            }"
                            :select-options="{
                            enabled: false,
                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                            selectionInfoClass: 'custom-class',
                            selectionText: 'rows selected',
                            clearSelectionText: 'clear',
                            }"
                            :search-options="{
                            enabled: false,
                            }">

                            <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                <div :key="key">
                                    <div>
                                        {{props.formattedRow[props.column.field]}}
                                    </div>
                                </div>
                            </template>

                            <div slot="selected-row-actions">
                                <button v-if="permit_value" id="deleteVehicleTypeBtn" v-on:click.prevent="VehiclePermitDelete" class="btn btn-success waves-effect">Delete</button>
                            </div>
                        </vue-good-table>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

    import Vue from "vue";





    import EventBus from "././event-bus";
    import {commonMixins} from '../mixins/commonMixins';
    import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "PermitCustomerList",
        mixins:[commonMixins,dataTableMixins],
        props: {
            permitValue: {
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: '#Permit',
                    field: 'permit_number',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Permit Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Permit Type',
                    field: 'permit_type',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Permit Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Customer',
                    field: 'customer',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },

                {
                    label: 'Amount',
                    field: 'amount',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Amount", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Amortized Amount',
                    field: 'amortized_amount',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Amortized Amount", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Effective Date',
                    field: 'from_date',
                    hidden:false,
                    fpFieldType:"date",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Expiry Date',
                    field: 'to_date',
                    fpFieldType:"date",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                // {
                //     label: 'Actions',
                //     field: 'action',
                //     sortable: false,
                // },
            ],
            rows: [],
            totalRecords: 0,
            asset_value: false,
            loading:false,
            permit_value:false,
            addPermit:false,
            assetId:"",
            selectedFile:"",
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent: false,
                toolbarPlacement:'bottom',
                widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
                },
            },
            effective_date:'',
            effective_date_error_msg:'',
            invoice_required:false,
            permitId:0,
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_asset_permit') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_asset_permit') {
                            self.addPermit = true;
                        }
                        if (permissions[i].name == 'delete_asset_permit') {
                            self.permit_value = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        beforeDestroy(){
            this.$root.$off('load_permit');
        },
        mounted: function() {
            var self = this;

            //when component list directly call from url instead of in view page than call permission request
            self.getPermissions();

            if ( self.$route.params.id){

                self.permitId = self.$route.params.id;
            }
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listPermitCustomerTable.unselectAllInternal();
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadList() {

                var self = this;

                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    vehicle_id: self.assetId,
                    sort: self.serverParams.sort,
                    permit_id:self.permitId
                    // exportFiltered: self.exportFilteredFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/permit-mapper/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");

                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            BackVehiclePermitList: function(){
                var self = this;

                self.$router.push("/vehiclepermit/list");
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/PermitCustomerMapper.vue